import { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import { colors } from 'styles/GlobalStyles';
import { H2, H3, P1 } from '../../../styles/FontStyles';
import { Div, Separator } from '../../../styles/Styles';
import { FormTitle } from '../Auth.styled';
import { InputComponent } from 'components/Input/Input';

import { GoogleButton } from '../GoogleButton';
import { Button } from 'components/Button/Button';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { signUp } from 'services/auth/auth.service';
import Spinner from 'components/Spinner/Spinner';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { CountryDropdown } from '../CountryDropdown';
import { useNavigate } from 'react-router';
import { removeUserFromLS } from 'helpers/localstorage-helper';
import { removeUserFromState } from 'slices';

const siteURL = process.env.REACT_APP_URL;

export const SignUp = () => {
  const navigate = useNavigate();

  const [firstName, setFirstName] = useState<string>('');
  const [lastName, setLastName] = useState<string>('');
  const [username, setUsername] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [country, setCountry] = useState<any>('');
  const [password, setPassword] = useState<string>('');
  const letterUpercaseAndSpace = /^[a-zA-Z\s]*$/;
  const [checked, setChecked] = useState<boolean>(false);

  const dispatch = useAppDispatch();

  const { loading } = useAppSelector((state) => state.authentication);

  const checkFirstName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      setFirstName(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const checkLastName = (e: string) => {
    if (e.match(letterUpercaseAndSpace)) {
      setLastName(
        e
          .replace(/|[0-9]/g, '')
          .toLowerCase()
          .split('profile_details. ')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      );
    } else {
      return;
    }
  };

  const onFormSubmit = (e: FormEvent) => {
    e.preventDefault();

    dispatch(
      signUp({
        firstName,
        lastName,
        username,
        email,
        country,
        password,
        navigate,
      })
    );
  };

  useEffect(() => {
    removeUserFromLS();
    dispatch(removeUserFromState());
  }, []);

  return (
    <>
      {loading && <Spinner fullscreen={true} transparent />}

      <H2 center m='50px 0' color={colors.primary}>
        Create an Account
      </H2>

      <P1 color={colors.white} center mb='40'>
        Sign up for personalized updates, exclusive deals,
        <br /> and content crafted just for you.
      </P1>

      <form onSubmit={onFormSubmit}>
        <Div $flex $gap='10px' $width='100%' $columnSM $gapSM='0'>
          <Div $width='100%'>
            {' '}
            <InputComponent
              placeholder='Name'
              label='First name'
              value={firstName}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                checkFirstName(e.target.value)
              }
            />{' '}
          </Div>
          <Div $width='100%'>
            <InputComponent
              placeholder='Surname'
              label='Last name'
              value={lastName}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                checkLastName(e.target.value)
              }
            />
          </Div>
        </Div>
        <InputComponent
          placeholder='Username'
          label='Username'
          value={username}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setUsername(e.target.value)
          }
        />
        <CountryDropdown country={country} setCountry={setCountry} label />

        <InputComponent
          placeholder='Enter email'
          type='email'
          label='Email address'
          value={email.replace(/\s+/g, '')}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setEmail(e.target.value.replace(/\s+/g, ''))
          }
        />
        <InputComponent
          placeholder='Type in password'
          type='password'
          label='Create Password'
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
        />
        {/* <InputComponent
          placeholder='Type in password'
          type='password'
          label='Create Password'
          value={password}
          onChange={(e: ChangeEvent<HTMLInputElement>) =>
            setPassword(e.target.value)
          }
        /> */}

        <Div $flex $gap='20px' $mb='20px' $mt='10px' $alignCenter>
          <Checkbox checked={checked} onClick={() => setChecked(!checked)} />
          <P1 color={colors.white}>
            By creating an account, I agree to our{' '}
            <a
              href={`/terms_of_service_travelution.pdf`}
              target='_blank'
              rel='noreferrer'
            >
              <span>Terms of use</span>
            </a>{' '}
            and
            <a
              href={`/privacy_policy_travelution.pdf`}
              target='_blank'
              rel='noreferrer'
            >
              <span> Privacy Policy</span>
            </a>
          </P1>
        </Div>

        <Button
          type='submit'
          disabled={
            !firstName ||
            !lastName ||
            !username ||
            !country ||
            !email ||
            !password ||
            !checked
          }
        >
          Sign Up
        </Button>
      </form>
      <Separator $m='30px 0' />
      <GoogleButton />
    </>
  );
};
